import { render } from "./HelpCenter.vue?vue&type=template&id=d6b268fc&ts=true"
import script from "./HelpCenter.vue?vue&type=script&lang=ts"
export * from "./HelpCenter.vue?vue&type=script&lang=ts"

import "./HelpCenter.vue?vue&type=style&index=0&id=d6b268fc&lang=scss"

import exportComponent from "/Users/zhouyuan/work/project/hand-mobile-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__